import Hero from "../components/landing/Hero";
import Problem from "../components/landing/Problem";
import Method from "../components/landing/Method";
import ServicesSection from "../components/landing/ServicesSection";
import WorkshopResources from "../components/landing/WorkshopResources";
import Audience from "../components/landing/Audience";
import AboutSection from "../components/landing/AboutSection";
import RigourSection from "../components/landing/RigourSection";
import BookCall from "../components/landing/BookCall";
import BriefingForm from "../components/landing/BriefingForm";
import Contact from "../components/landing/Contact";
import { usePageMeta } from "../lib/seo";
import { useEffect, useRef } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  usePageMeta(
    "Bigibila Research | First Nations-Led Governance, Workshops & Briefings",
    "Bigibila delivers First Nations-led governance analysis, Indigenous Data Sovereignty, cultural assurance, facilitated workshops and confidential briefings.",
    "/"
  );
  const tracked = useRef(false);
  useEffect(() => {
    if (tracked.current) return;
    tracked.current = true;
    axios.post(`${API}/track/pageview`, { path: window.location.pathname }).catch(() => {});
  }, []);
  return (
    <>
      <Hero />
      <Problem />
      <Method />
      <ServicesSection />
      <WorkshopResources />
      <Audience />
      <AboutSection />
      <RigourSection />
      <BookCall />
      <BriefingForm />
      <Contact />
    </>
  );
}
